import { linePadding } from "./constants";
import { DrawParams } from "./types";

export default function drawCorrectFreqLine({
  svg,
  xScale,
  correctFreq,
  contentHeight,
}: DrawParams) {
  const selector = "correctFreqLine";

  svg
    .selectAll(`line.${selector}`)
    .data(correctFreq ? [correctFreq] : [])
    .join("line")
    .attr("class", `${selector} stroke-red-500 animate-pulse`)
    .attr("fill", "none")
    .attr("stroke-width", 4)
    .attr("x1", (d) => xScale(d))
    .attr("x2", (d) => xScale(d))
    .attr("y1", 0)
    .attr("y2", contentHeight);

  svg
    .selectAll(`text.${selector}`)
    .data(correctFreq ? [correctFreq] : [])
    .join("text")
    .attr(
      "class",
      `${selector} fill-red-500 animate-pulse font-rogan font-bold select-none`
    )
    .attr("style", "text-anchor: middle;")
    .attr("transform", "rotate(-90)")
    .attr("x", () => -contentHeight + linePadding.bottom)
    .text("Correct Frequency")
    .attr("y", (d) => xScale(d) - 10);
}
